import { useCallback } from "react";
import { UseProjectHeaderActionsProps } from "@shared/interfaces/ProjectsFiles";

export const useProjectHeaderActions = ({
  isEditing,
  selectedProject,
  setIsEditing,
  setEditedProject,
  fetchUpdatedProject,
  setIsShareMenuOpen,
  setIsMemberModalOpen,
  setIsDeletePopupOpen,
  shareMenuRef,
  reducedShareMenuRef,
  shareButtonRef,
  memberButtonRef,
}: UseProjectHeaderActionsProps) => {
  const handleOutsideClick = useCallback((event: MouseEvent) => {
    if (
      shareMenuRef &&
      shareMenuRef.current &&
      !shareMenuRef.current.contains(event.target as Node) &&
      shareButtonRef &&
      shareButtonRef.current &&
      !shareButtonRef.current.contains(event.target as Node)
    ) {
      setIsShareMenuOpen(false);
    } else if (
      reducedShareMenuRef &&
      reducedShareMenuRef.current &&
      !reducedShareMenuRef.current.contains(event.target as Node) &&
      memberButtonRef &&
      memberButtonRef.current &&
      !memberButtonRef.current.contains(event.target as Node)
    ) {
      setIsMemberModalOpen(false);
    }
  }, []);

  const handleShareButtonClick = useCallback(() => {
    setIsShareMenuOpen((prev) => !prev);
  }, []);

  const handleMemberButtonClick = useCallback((event: React.MouseEvent) => {
    event.stopPropagation();
    setIsMemberModalOpen((prev) => !prev);
  }, []);

  const handleEditClick = useCallback(() => {
    if (!isEditing && selectedProject) {
      setEditedProject({ ...selectedProject });
      setIsEditing(true);
    }
  }, [isEditing, selectedProject]);

  const toggleDeleteModal = useCallback(() => {
    setIsDeletePopupOpen((prev) => !prev);
  }, []);

  const handleDiscardChanges = useCallback(() => {
    setIsEditing(false);
    fetchUpdatedProject();
  }, [fetchUpdatedProject]);

  return {
    handleOutsideClick,
    handleShareButtonClick,
    handleMemberButtonClick,
    handleEditClick,
    toggleDeleteModal,
    handleDiscardChanges,
  };
};
